export const errorFactory = (error: unknown): Error => {
  let e: Error = new Error(typeof error === "string" ? error : "Unknown Error");
  if (error instanceof Error) {
    e = error;
  }
  return e;
};
